// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface V1SpdConfig
 */
export interface V1SpdConfig {
  /**
   *
   * @type {string}
   * @memberof V1SpdConfig
   */
  graphSeedUri?: string;
  /**
   *
   * @type {number}
   * @memberof V1SpdConfig
   */
  numOfShardReplicas?: number;
  /**
   *
   * @type {number}
   * @memberof V1SpdConfig
   */
  numOfShards?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof V1SpdConfig
   */
  propertyShardSeedUris?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof V1SpdConfig
   */
  seedType?: string;
  /**
   *
   * @type {string}
   * @memberof V1SpdConfig
   */
  seedUri?: string;
}

/**
 * Check if a given object implements the V1SpdConfig interface.
 */
export function instanceOfV1SpdConfig(value: object): value is V1SpdConfig {
  return true;
}

export function V1SpdConfigFromJSON(json: any): V1SpdConfig {
  return V1SpdConfigFromJSONTyped(json, false);
}

export function V1SpdConfigFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1SpdConfig {
  if (json == null) {
    return json;
  }
  return {
    graphSeedUri:
      json['graphSeedUri'] == null ? undefined : json['graphSeedUri'],
    numOfShardReplicas:
      json['numOfShardReplicas'] == null
        ? undefined
        : json['numOfShardReplicas'],
    numOfShards: json['numOfShards'] == null ? undefined : json['numOfShards'],
    propertyShardSeedUris:
      json['propertyShardSeedUris'] == null
        ? undefined
        : json['propertyShardSeedUris'],
    seedType: json['seedType'] == null ? undefined : json['seedType'],
    seedUri: json['seedUri'] == null ? undefined : json['seedUri'],
  };
}

export function V1SpdConfigToJSON(json: any): V1SpdConfig {
  return V1SpdConfigToJSONTyped(json, false);
}

export function V1SpdConfigToJSONTyped(
  value?: V1SpdConfig | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    graphSeedUri: value['graphSeedUri'],
    numOfShardReplicas: value['numOfShardReplicas'],
    numOfShards: value['numOfShards'],
    propertyShardSeedUris: value['propertyShardSeedUris'],
    seedType: value['seedType'],
    seedUri: value['seedUri'],
  };
}
